import { useEffect, useState, useSyncExternalStore } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import {
  checkForAppUpdate,
  isAppUpdateAvailable,
  subscribeToAppUpdate,
} from '../../services/appVersionService';
import { usePhoneLayout } from '../../hooks/usePhoneLayout';
import { MOBILE_NAVIGATION_MIN_HEIGHT } from './MobileNavigation';

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

export function AppUpdatePrompt() {
  const phone = usePhoneLayout();
  const available = useSyncExternalStore(
    subscribeToAppUpdate,
    isAppUpdateAvailable,
  );
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const check = () => {
      if (document.visibilityState === 'visible') void checkForAppUpdate();
    };
    const interval = window.setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener('visibilitychange', check);
    window.addEventListener('focus', check);
    window.addEventListener('online', check);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', check);
      window.removeEventListener('focus', check);
      window.removeEventListener('online', check);
    };
  }, []);

  return (
    <Snackbar
      open={available && !dismissed}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={
        phone
          ? {
              bottom: `calc(${MOBILE_NAVIGATION_MIN_HEIGHT + 8}px + env(safe-area-inset-bottom))`,
            }
          : undefined
      }
    >
      <Alert
        severity="info"
        variant="filled"
        onClose={() => setDismissed(true)}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => window.location.reload()}
          >
            Reload
          </Button>
        }
        sx={{ width: '100%' }}
      >
        A new version of qkIndex is available. Reload to keep everything
        working.
      </Alert>
    </Snackbar>
  );
}
